module.exports = __webpack_public_path__ + "img/icon-usp-world.e2cbaf50.svg";